(function () {
  function initShowMore(button) {
    var section = button.closest('.wa-testimonials');
    if (!section) return;

    button.addEventListener('click', function () {
      var hiddenItems = section.querySelectorAll('.wa-testimonials__item--hidden');
      hiddenItems.forEach(function (item) {
        item.classList.remove('wa-testimonials__item--hidden');
      });
      button.parentElement.style.display = 'none';
    });
  }

  function initAll() {
    var buttons = document.querySelectorAll('[data-wa-show-more]');
    buttons.forEach(initShowMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();